import { Injector } from '@angular/core';
import { Middleware } from '../connectors/backend';
import { AuthService } from '../services/auth-service';

/**
 * Back to the login on a 401 while signed in; with no user the 401 is left to login and public
 * pages. Resolved lazily to avoid a DI cycle through `Configuration`.
 */
export function logoutOnUnauthorized(injector: Injector): Middleware {
  return {
    async post({ response }) {
      if (response.status !== 401) return;
      const auth = injector.get(AuthService);
      if (auth.me()) auth.toLogin();
    },
  };
}
